const DataPhone = {
  phone: '0964040895',
  phone_dot: '096.4040.895'
}

export default DataPhone
